import { API } from 'aws-amplify';
import requestBuilder from '@/services/graphql/requestBuilder';

export default {
  getDashboardData(variables, abortController) {
    const query = new requestBuilder({
      requestName: 'getDashboardAnalyticsData',
      requestVariables: {
        workspaceId: 'String!',
      },
      responseWrapperText: 'dashboardData',
      variables,
    }).buildQuery();

    const req = API.graphql({
      query,
      variables,
    });

    abortController?.addRequest(req);
    return req;
  },
};